<template>
  <div class="vx-row">
    <div class="w-full lg:w-full border border-solid d-theme-border-grey-light rounded">
      <div class="vx-card" style="padding:10px;">
      <div class="vx-card__collapsible-content text-center" style="margin:-5px;">
        <div class="vx-row justify-end">
          <div class="flex items-center" style="margin-right:65px; margin-top:3px;">
        <!-- <div class="flex items-center ml-auto" style="padding:3px;"> -->
            <vs-checkbox v-if="inviteInfo.level !=5 && activeUserLevel > 2" v-model="checkBoxValue"/>
          </div>
            <div class="vx-row justify-end" style="margin-right:15px; margin-top:3px;">
              <div class="flex items-center">
              <vs-chip v-if="inviteInfo.level == 1" transparent color="primary" style="padding-left:10px; margin-right:10px;"> 읽기 &nbsp;&nbsp;</vs-chip>
              <vs-chip v-if="inviteInfo.level == 2" transparent color="warning"> 읽기/쓰기 </vs-chip>
              <vs-chip v-if="inviteInfo.level == 3" color="primary" style="padding-left:5px; margin-right:8px;"> 관리자 &nbsp;</vs-chip>
              <vs-chip v-if="inviteInfo.level == 5" color="warning"> 생성자 </vs-chip>
          <!-- <vs-avatar size="40px"/> -->
          <!-- <div style="text-overflow: ellipsis; width:80px; overflow: hidden; white-space: nowrap; display: block;">{{inviteInfo.name}}</div> -->
            </div>
          </div>
        </div>
          <div class="text-center md:1/3">
            <div class="vx-row">
              <img :src="memberphoto" style="width:40px; height:40px; margin-top:3px; margin-bottom:3px; margin-left:15px;" class="mr-4 mb-4"/>
                <div style="text-overflow: ellipsis; width:90px; overflow: hidden; white-space: nowrap; display: block; margin:15px;">{{inviteInfo.name}}</div>
            </div>
          </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['inviteInfo','checkValue'],
    data() {
        return {
            name: '',
            inviteId:0,
            checkBoxValue:false,
            memberphoto:''
        }
    },
    computed: {
      // scrollbarTag() { return this.$store.getters.scrollbarTag },
      // activeSpaceInfo() {
      //   return this.$store.state.space.ActiveSpaceInfo
      // },
      activeUserLevel() {
        return this.$store.state.space.ActiveDashBoardLevel
      }
    },
    watch: {
      checkBoxValue(val){
        this.$store.commit('space/UPDATE_WORKSPACE_MEMBERS_CHECKBOX', {'id':this.inviteInfo.id, 'checkValue':val})
        this.$emit('selectUser', this.checkBoxValue)
      },
      checkValue(val){
        this.checkBoxValue = val
      }
    },
    created () {
      this.memberphoto = require("@/assets/images/portrait/small/"+this.inviteInfo.photo_url)
      this.checkBoxValue = this.checkValue
    }
  }
</script>
